import {Box} from "@mui/material";
import styled from "styled-components";



export const Container = styled.div`
  background-image: linear-gradient( #629ff1 , #FFFFFF );
	z-index: 1;
	width: 100%;
	@media screen and (max-width: 768px) {
    padding-right: 10px;
		padding-left: 10px;
	}
`;

export const Logo = styled(Box)`
`;
export const Sponsor_Box = styled(Box)`
  justifyContent: center;
  alignItems: center;
  margin-top: 60px;
`;


export const Heading = styled.h1`
	max-width: 100%;
  margin-top: 140px;
  margin-left: 45px;
	font-size: 63px;
	font-weight: bolder;
  text-align: left;
	line-height: 70px;
	color: #000000;

  @media (max-width: 768px) {
    font-size: 50px; 
  }

  @media (max-width: 375px) {
    font-size: 40px;
  }

  @media (max-width: 325px) {
    font-size: 45px;
  }
`;

export const Subtitle = styled.p`
	max-width: 100%;
	margin-bottom: 15px;
  margin-left: 45px;
	font-size: 24px;
  text-align: left;
	line-height: 15px;
	color: #000000;
`;

export const ResponsiveText = styled.p`
  font-weight: 400;
  line-height: 1.5;
  font-size: 24px;
  margin: 0;
  padding: 0;
  text-align: left;
  width: 100%;
  word-wrap: break-word;
  }
  @media only screen and (max-width: 768px) {
      font-size: 20px;
  }
  @media only screen and (max-width: 480px) 
      font-size: 12px;
  }
  @media screen and (max-width: 375px){
      font-size: 16px;
  }
  
  @media screen and (max-width: 325px){
      font-size: 16px;
  }
`;

export const Spacing = styled.p`
  padding: 20px;
`;
